import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import {
  ProcessTypeListBodyObj,
  IDeleteDataObj,
  IDeleteConfDataObj,
  ITemplate,
  ServiceLine,
  ISaveCorrespondenceActivity,
  Activity,
  ProcessType,
  isApplicantsActivityAvailable,
  dashboardData,
  SimpleActivity,
  DataIds,
  InterviewActivity,
  StatusChangeActivity,
  Venue,
  Status,
  CorrespondenceActivity,
  ISaveSimpleActivity,
  ISaveInterviewActivity,
  ISaveStatusChangeActivity,
  HrPanelInterviewActivity,
  OfferRevokeDetails,
} from 'src/app/shared/models/activity-dashboard-model';
import { Observable, Subject, retry, timer} from '../../../../node_modules/rxjs';

//snack bar :)
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../../shared/components/snackbar/snackbar.component';

import { environment } from '../../../environments/environment.prod';
import { assetUrl } from 'src/single-spa/asset-url';

// if in dev mode
// import{ environment } from '../../../environments/environment';
// if in qa mode
//import { environment } from '../../../environments/environment.qa';
// if in prod mode
//import{ environment } from '../../../environments/environment.prod';

// import { Template } from '@angular/compiler/src/render3/r3_ast';

@Injectable({
  providedIn: 'root',
})
export class ActivityService {
  objA: any;
  activity: any;

  constructor(
    private httpclient: HttpClient,
    private snackBar: MatSnackBar,
  ) {}

  // base url from environment file
  readonly BASE_URL: string = environment.activityUrl;
  readonly serviceline_URL: string = environment.apiUrl;
  readonly confirmation_url: string = environment.confirmationActivityUrl;
  readonly offerWfUrl: string = environment.offerWF;
  readonly offerTestUrl: string = environment.offerTest;
  readonly offerDB_URL: string = environment.offerDBUrl;
  supportUrl = environment.supportEmpUrl;
  recruiterUrl = environment.recruiterUrl;
  adminUrl = environment.AdminUrl;
  excelApiUrl = environment.ExcelApiUrl;
  loggedUserDetailsUrl = environment.loggedUserDetailsUrl;
  readonly mongoApiUrl = environment.mongoApiUrl;
  readonly schedulerDashboardUrl = environment.schedulerDashboardUrl;
  readonly ProfileUrl = environment.profileUrl;
  resumePushUrl = environment.resumePushUrl;
  genModelUrl = environment.genModelUrl;
  readonly recruiterDashboardUrl = environment.recruiterdashboardUrl;
  readonly careerUrl = environment.careerUrl;
  readonly validationUrl = environment.validationUrl;

  emailAPI: string = environment.mailerServiceUrl + 'mail/sendMail';
  addressApi: string = environment.mailerServiceUrl;

  private options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };

  saveSimpleActivityUrl = this.BASE_URL + 'activity/saveSimpleActivity';
  editSimpleActivityUrl = this.BASE_URL + 'activity/editSimpleActivity';

  saveInterviewActivityUrl = this.BASE_URL + 'activity/saveInterviewActivity';
  editInterviewActivityUrl = this.BASE_URL + '/activity/editInterviewActivity';

  saveStatusChangeUrl = this.BASE_URL + 'activity/saveAppStatusChange';
  editStatusChangeUrl = this.BASE_URL + 'activity/editAppStatusChange';
  candidateHiringNameUrl = environment.candidateHiringNameUrl;

  dataIds: DataIds = { activityID: 0, processID: 0, applicationId: 0 };
  multiAppId: number[] = [0, 0, 0];
  id = localStorage.getItem('fresherCompHiringTypeId');
  private lastActivity;
  private allActivity;
  private _check = new Subject<any>();
  candObject: any;
  retryDelay = window["retryDelay"];
  // activity: any;
  //snack bar method; duration in milliseconds,data is message to display, panelClass is css class from ts
  openSnackBar(message: any, panelClass: string, duration?: number) {
    console.log('activity service snackbar');
    console.log(message);
    this.snackBar.openFromComponent(SnackbarComponent, {
      data: message,
      panelClass: panelClass,
      duration: duration || 6500,
    });
  }
  // api call
  getDashboardData() {
    return this.httpclient.get<dashboardData[]>(this.BASE_URL + 'activity/getAllApplicants?tenantId=1');
  }

  getVenue() {
    return this.httpclient.get<Venue[]>(this.BASE_URL + 'activity/getVenues?companyHiringTypeId=' + this.id);
  }
  getServiceLine() {
    return this.httpclient.get<ServiceLine[]>(this.serviceline_URL + 'getUnitDetails/application');
  }
  getApplicationList(id, mode, hiringid) {
    const url = this.adminUrl + 'adminApplication//getListOfApplication/' + id + '/' + hiringid + '/' + mode;
    //console.log(ab)adminApplication//getListOfApplication/1001805647/1
    return this.httpclient.get<any>(url);
  }
  candidateStatusCheck(payload) {
    const url = this.excelApiUrl + 'adminCandidate/candidateStatusCheck';
    return this.httpclient.post<any>(url, payload);
  }
  confirmDeleteCandidate(payload) {
    const url = this.excelApiUrl + 'adminCandidate/candidateRequestDeletion';
    return this.httpclient.post<any>(url, payload);
  }
  confirmDeleteActivity(payload) {
    const url = this.adminUrl + 'adminActivity/activitiesRequestDeletion';
    return this.httpclient.post<any>(url, payload);
  }
  deleteActivityDialogue(payload) {
    const url = this.adminUrl + 'adminActivity/updatedActivity';
    return this.httpclient.post<any>(url, payload);
  }
  deleteApplication(payload) {
    const url = this.adminUrl + 'adminApplication/ApplicationDeletionRequest';
    return this.httpclient.post<any>(url, payload);
  }
  getActivityList(id) {
    const url = this.adminUrl + 'adminActivity/getAdminActivityList?applicationId=' + id;
    return this.httpclient.get<any>(url);
  }
  getTemplate(activityid: number, processid: number) {
    // return this.httpclient.get<ITemplate[]>(this.BASE_URL + 'activity/getTemplates');
    // return this.httpclient.get<ITemplate[]>(this.BASE_URL +'activity/getTemplates?processId=40&activityID=400101&companyHiringTypeId=1');
    return this.httpclient.get<ITemplate[]>(
      this.BASE_URL +
        'activity/getTemplates?processId=' +
        processid +
        '&activityID=' +
        activityid +
        '&companyHiringTypeId=' +
        this.id,
    );
  }
  dnhLogs(ObjD) {
    const requestOptions: object = {
      responseType: 'text',
    };
    return this.httpclient.post<any>(this.offerWfUrl + 'v1/dnh/dnhLogs', ObjD, requestOptions);
  }
  setDnhReject(actId: number, cid: number, appId: number) {
    const requestOptions: object = {
      responseType: 'text',
    };
    return this.httpclient.get<any>(
      this.offerWfUrl + 'v1/dnh//dnhreject/' + actId + '/' + cid + '/' + appId,
      requestOptions,
    );
  }
  getBcgStatus(appId, actId, hiringId) {
    const requestOptions: object = {
      responseType: 'text',
    };
    const bgcStatusUrl = this.schedulerDashboardUrl.split('v1')[0];
    const url = `${bgcStatusUrl}candBgcPendingStatus?applicationId=${appId}&activityId=${actId}&hiringId=${hiringId}`;
    return this.httpclient.get<any>(url, requestOptions);
  }
  getTemplateDuplicateChceck(ids) {
    let params = new HttpParams();
    params = params.append('processId', ids.processId);
    params = params.append('activityID', ids.activityId);
    params = params.append('companyHiringTypeId', ids.companyHiringTypeId);
    return this.httpclient.get<ITemplate[]>(this.BASE_URL + 'activity/getTemplates', { params: params });
    //  return this.httpclient.get<ITemplate[]>('https://intaptest.infosysapps.com/infosys/intapactivity/v1/activity/getTemplates', { params: params });
    //return this.httpclient.get<ITemplate[]>(this.BASE_URL + 'activity/getTemplates?processId='+ids.processid+'&activityID='+ids.activityid+'&companyHiringTypeId='+ids.companyHiringTypeId);
  }

  getStatusDropDown() {
    return this.httpclient.get<Status[]>(this.BASE_URL + 'activity/getStatus');
  }

  getActivityReasons(activityId) {
    // return this.httpclient.get(assetUrl('./json/getAllReasons.json'));
    return this.httpclient.get<any>(
      this.BASE_URL + 'activity/getAllReasons?companyHiringTypeId=' + this.id + '&activityID=' + activityId,
    );
  }

  getReasons() {
    return this.httpclient.get(assetUrl('./json/getAllReasons.json'));
  }
  // as of now json data

  applicationStatus(obj) {
    return this.httpclient.get<any>(
      this.recruiterDashboardUrl + 'v1/Hrpanel/getUanBgLpStatus/' + obj.candidateId + '/' + obj.applicationId,
    );
  }
  getProcessType(_body: ProcessTypeListBodyObj): ProcessType[] {
    const a1: Activity = { activityId: 101, activityName: 'Black Listed' };
    const a2: Activity = { activityId: 101, activityName: 'DNH' };
    const a3: Activity = { activityId: 113, activityName: 'F2F' };
    const a4: Activity = { activityId: 113, activityName: 'Scheduling Telephonic' };
    const a5: Activity = { activityId: 113, activityName: 'GTM' };
    const a6: Activity = { activityId: 122, activityName: 'ROA' };
    const a7: Activity = { activityId: 122, activityName: 'TBS' };

    const obj: ProcessType[] = [
      { processId: 999, processName: 'Pre Screening', activities: [a1, a2] },
      { processId: 999, processName: 'Screening', activities: [a6, a7] },
      { processId: 999, processName: 'Interview', activities: [a3, a4, a5] },
    ];
    return obj;
  }

  isApplicantsActivityAvailable(): Observable<isApplicantsActivityAvailable> {
    const url =
      this.BASE_URL +
      'activity/isApplicantsActivityAvailable?applicationId=' +
      this.getDataIds().applicationId +
      '&processID=' +
      this.getDataIds().processID +
      '&activityID=' +
      this.getDataIds().activityID;
    // this.BASE_URL+'v1/activity/isApplicantsActivityAvailable?applicationId='+this.getDataIds().applicationId+'&processID='+this.getDataIds().processID+'&activityID='+this.getDataIds().activityID;
    // console.log(url);
    return this.httpclient.get<isApplicantsActivityAvailable>(url);
  }

  getSimpleActivity(
    applicationId: number,
    activityId: number,
    processId: number,
    createdOn: string,
  ): Observable<SimpleActivity> {
    // let url = this.BASE_URL+'activity/getSimpleActivityById?applicationId=' + applicationId + '&processID=' + processId + '&activityID=' + activityId;

    // let url = this.BASE_URL+'activity/getSimpleActivityById?applicationId=' + applicationId + '&processID=' + processId + '&activityID=' + activityId+'&companyHiringTypeID='+this.id+'&createdOn='+createdOn;
    // this.BASE_URL+'v1/activity/getSimpleActivityById?applicationId='+this.getDataIds().applicationId+'&processID='+this.getDataIds().processID+'&activityID='+this.getDataIds().activityID;
    // console.log(url);
    const url = this.BASE_URL + 'activity/getSimpleActivityById';
    const body = {
      applicationId: applicationId,
      processID: processId,
      activityID: activityId,
      createdOn: createdOn,
    };
    return this.httpclient.post<any>(url, body, this.options);
    // return this.httpclient.get<SimpleActivity>(url, this.options);
  }
  getFaceValidationData(applicationId) {
    return this.httpclient.get<any>(this.validationUrl + 'validate/validatePhoto?applicationId=' + applicationId);
  }
  editSimpleActivity(object: SimpleActivity): Observable<string> {
    const requestOptions: object = {
      responseType: 'text',
    };
    return this.httpclient.post<string>(this.editSimpleActivityUrl, object, requestOptions);
  }

  saveSimpleActivity(object: ISaveSimpleActivity): Observable<string> {
    // const requestOptions: Object = {
    //   responseType: 'text'
    // }
    return this.httpclient.post<any>(this.saveSimpleActivityUrl, object);
  }

  // Services for Interview Activity

  getInterviewActivity(
    applicationId: number,
    activityId: number,
    processId: number,
    createdOn: string,
  ): Observable<InterviewActivity> {
    // let url = this.BASE_URL + 'activity/getInterviewActivityById?applicationId=' + applicationId + '&processID=' + processId + '&activityID=' + activityId;
    // let url = this.BASE_URL + 'activity/getInterviewActivityById?applicationId=' + applicationId + '&processID=' + processId + '&activityID=' + activityId+'&companyHiringTypeID='+this.id+'&createdOn='+createdOn;

    const url = this.BASE_URL + 'activity/getInterviewActivityById';

    const body = {
      applicationId: applicationId,
      processID: processId,
      activityID: activityId,
      createdOn: createdOn,
    };
    return this.httpclient.post<any>(url, body, this.options);
    // return this.httpclient.get<InterviewActivity>(url, this.options);
  }

  editInterviewActivity(object: InterviewActivity): Observable<any> {
    const requestOptions: object = {
      responseType: 'text',
    };
    return this.httpclient.post<any>(this.editInterviewActivityUrl, object, requestOptions);
  }

  saveInterviewActivity(object: ISaveInterviewActivity): Observable<any> {
    // const requestOptions: Object = {
    //   responseType: 'text'
    // }
    return this.httpclient.post<any>(this.saveInterviewActivityUrl, object);
  }

  deleteInterviewActivity(obj: IDeleteDataObj): Observable<any> {
    const requestOptions: object = {
      responseType: 'text',
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      body: obj,
    };
    const url = this.BASE_URL + 'activity/deleteInterviewActivity';
    return this.httpclient.delete<string>(url, requestOptions);
  }

  // Services for Status Change Activity

  getStatusChangeActivity(
    applicationId: number,
    activityId: number,
    processId: number,
    createdOn: string,
  ): Observable<StatusChangeActivity> {
    // let url = this.BASE_URL + 'activity/getAppStatusChangeById?applicationId=' +applicationId + '&processID=' + processId + '&activityID=' + activityId;
    // let url = this.BASE_URL + 'activity/getAppStatusChangeById?applicationId=' +applicationId + '&processID=' + processId + '&activityID=' + activityId+'&companyHiringTypeID=1&createdOn='+createdOn;
    //  let url = this.BASE_URL + 'activity/getInterviewActivityById?applicationId=' + applicationId + '&processID=' + processId + '&activityID=' + activityId;
    // return this.httpclient.get<StatusChangeActivity>(url, this.options);

    const url = this.BASE_URL + 'activity/getAppStatusChangeById';

    const body = {
      applicationId: applicationId,
      processID: processId,
      activityID: activityId,
      createdOn: createdOn,
    };
    return this.httpclient.post<any>(url, body, this.options);
  }
  // setAct(act){
  //   this.activity = act;
  // }

  // getAct(){
  //   return this.activity;
  // }

  setObj(objA) {
    this.objA = objA;
  }

  getObj() {
    return this.objA;
  }

  getAct() {
    return this.activity;
  }
  setAct(act) {
    this.activity = act;
  }

  getObject() {
    return this.candObject;
  }
  setObject(candObject) {
    this.candObject = candObject;
  }

  saveStatusChangeActivity(object: ISaveStatusChangeActivity): Observable<any> {
    // const requestOptions: Object = {
    //   responseType: 'text'
    // }
    return this.httpclient.post<any>(this.saveStatusChangeUrl, object);
  }

  editStatusChangeActivity(object: StatusChangeActivity): Observable<any> {
    const requestOptions: object = {
      responseType: 'text',
    };
    return this.httpclient.post<any>(this.editStatusChangeUrl, object, requestOptions);
  }

  deleteStatusChangeActivity(obj: IDeleteDataObj): Observable<any> {
    const requestOptions: object = {
      responseType: 'text',
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      body: obj,
    };
    const url = this.BASE_URL + 'activity/deleteAppStatusChange';
    return this.httpclient.delete<any>(url, requestOptions);
  }

  setDataIds(idObj: DataIds) {
    console.log(idObj);
    this.dataIds.applicationId = idObj.applicationId;
    // 4444;    //
    this.dataIds.activityID = idObj.activityID;
    // 101;
    this.dataIds.processID = idObj.processID;
    // 999;
    console.log('data ids', idObj);
  }

  getDataIds(): DataIds {
    return this.dataIds;
  }

  getCorrespondenceActivity(
    applicationId: number,
    activityId: number,
    processId: number,
    createdOn: string,
  ): Observable<CorrespondenceActivity> {
    // let getCorrespondenceActivityUrl: string = this.BASE_URL + 'activity/getCorrespondenceActivityById?applicationId=' +
    //   applicationId + '&processID=' + processId + '&activityID=' + activityId+'&companyHiringTypeID=1'+'&createdOn='+createdOn;
    // let getCorrespondenceActivityUrl: string = this.BASE_URL + 'activity/getCorrespondenceActivityById?applicationId=' +
    // applicationId + '&processID=' + processId + '&activityID=' + activityId+'&companyHiringTypeID='+this.id+'&createdOn='+createdOn;
    // console.log(getCorrespondenceActivityUrl);
    // return this.httpclient.get<CorrespondenceActivity>(getCorrespondenceActivityUrl, this.options);

    const url = this.BASE_URL + 'activity/getCorrespondenceActivityById';

    const body = {
      applicationId: applicationId,
      processID: processId,
      activityID: activityId,
      createdOn: createdOn,
    };
    return this.httpclient.post<any>(url, body, this.options);
  }
  saveCorrespondenceActivity(object: ISaveCorrespondenceActivity): Observable<any> {
    const saveCorrespondenceActivityUrl: string = this.BASE_URL + 'activity/saveCorrespondenceActivity';
    // const requestOptions: Object = {
    //   responseType: 'text'
    // }
    return this.httpclient.post<any>(saveCorrespondenceActivityUrl, object);
  }

  // edit corres activity cc bcc subkect and body values
  editCorrespondenceActivity(obj: CorrespondenceActivity): Observable<CorrespondenceActivity> {
    // console.log('data ---->', data);
    const editCorrespondenceActivityUrl: string = this.BASE_URL + 'activity/editCorrespondenceActivity';
    // let  headers  =  new  HttpParams().set('Content-Type', 'application/json');
    const requestOptions: object = {
      responseType: 'text',
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    };

    return this.httpclient.post<CorrespondenceActivity>(editCorrespondenceActivityUrl, obj, requestOptions);
  } // end of edit

  // save correspondence activity

  deleteCorrespondenceActivity(obj: IDeleteDataObj): Observable<string> {
    const deleteCorrespondenceActivityUrl = this.BASE_URL + 'activity/deleteCorrespondenceActivity';
    const requestOptions: object = {
      responseType: 'text',
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      body: obj,
    };
    console.log('Inside delete service function');
    return this.httpclient.delete<string>(deleteCorrespondenceActivityUrl, requestOptions);
  }

  deleteSimpleActivity(obj: IDeleteDataObj): Observable<string> {
    // console.log(this.getDataIds().applicationId);
    // console.log(this.getDataIds().processID);
    // console.log(this.getDataIds().activityID);
    // let deleteSimpleActivityUrl = this.BASE_URL + 'v1/activity/deleteSimpleActivity?applicationId=' +
    //   this.getDataIds().applicationId + '&processID=' + this.getDataIds().processID + '&activityID=' + this.getDataIds().activityID;

    // let deleteSimpleActivityUrl1=this.BASE_URL + 'v1/activity/deleteSimpleActivity?applicationId=' +
    // applicationId + '&processID=' + processId + '&activityID=' + activityId;
    const deleteUrl1 = this.BASE_URL + 'activity/deleteSimpleActivity';
    const requestOptions: object = {
      responseType: 'text',
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      body: obj,
    };
    console.log('Inside delete service function');
    // console.log("DELETE URL !!!!!!!!!!!!" + deleteSimpleActivityUrl1);
    // console.log("previous dat"+ deleteSimpleActivityUrl);
    console.log(requestOptions);
    return this.httpclient.delete<string>(deleteUrl1, requestOptions);
  }

  sendEmail(mailbody) {
    const requestOptions: object = {
      responseType: 'text',
    };
    console.log('inside email service');
    console.log(this.emailAPI);
    console.log(mailbody);
    return this.httpclient.post(this.emailAPI, mailbody, requestOptions);
  }

  getReferenceActivity(): Observable<any> {
    return this.httpclient.get<object>(this.confirmation_url + 'getConfirmationResults');
  }

  getRoles(): Observable<any> {
    return this.httpclient.get<object>(this.confirmation_url + 'getRoles');
  }

  getSurveyTechFeedback(obj) {
    const url = this.genModelUrl + 'RecruiterModule/SurveyTechfeedbackController';
    return this.httpclient.post<any>(url, obj);
  }

  saveEditHrPanelInterview(obj: HrPanelInterviewActivity) {
    const url = this.confirmation_url + 'saveEditConfirmationApplication';
    return this.httpclient.post<any>(url, obj);
  }
  getHrPanelActivity(applicationid, activityid, createdOn: string) {
    const url = this.confirmation_url + 'getActivityConfirmationHRPanelist';

    const body = {
      applicationId: applicationid,

      activityId: activityid,
      createdOn: createdOn,
    };
    return this.httpclient.post<any>(url, body, this.options);
  }

  deleteConfirmationActivity(obj: IDeleteConfDataObj): Observable<string> {
    const deleteConfirmationActivityUrl = this.confirmation_url + 'deleteConfirmationHRPanelist';
    const requestOptions: object = {
      responseType: 'text',
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      body: obj,
    };
    console.log('Inside delete service function');
    return this.httpclient.delete<string>(deleteConfirmationActivityUrl, requestOptions);
  }
  saveExInfyLog(body) {
    const requestOptions: object = {
      responseType: 'text',
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    };
    return this.httpclient.post<any>(this.ProfileUrl + 'profileService/saveExInfyLog', body, requestOptions);
  }
  getCandidateOfferUpdate(applicationId) {
    return this.httpclient.get<any>(this.offerTestUrl + 'v1/role/applicationOfferDetails/' + applicationId);
  }
  launchpadOfferId(offerId) {
    return this.httpclient.post(
      this.offerWfUrl + 'v1/launchpad/insertCandidateDatawithImageLaunchpadDataByOfferId/' + offerId,
      {},
    );
  }

  updateOfferDetails(body) {
    const requestOptions: object = {
      responseType: 'text',
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    };
    return this.httpclient.post<any>(this.offerWfUrl + '/v1/DOJ/updatedoj', body, requestOptions);
    // localhost:8081/v1/DOJ/updatedoj?offerId=10052&applicationId=1304&doj=2020-06-19 00:00:00&location=CHANDIGARH&puCode=CCD
  }
  updateOfferDetailIL(id, odObject) {
    const requestOptions: object = {
      responseType: 'text',
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    };
    return this.httpclient.post<any>(this.offerTestUrl + 'v1/role/updateOfferDetails/' + id, odObject, requestOptions);
  }

  fileUpload(data) {
    const uploadURL = this.mongoApiUrl + '/uploadFileData';
    const request$ =  this.httpclient.post<any>(uploadURL, data);
    return this.retryDelay
      ? request$.pipe(retry({ count: 1, delay: (error) => {
          if (error instanceof HttpErrorResponse && error.status === 502) {
            console.log('retrying now...');
            return timer(this.retryDelay);
          }
          throw error;
        } }))
      : request$;
  }

  sendJoiningBonusFile(body) {
    return this.httpclient.post<any>(this.offerWfUrl + '/updateOfferDetails/addJoiningBonus', body);
  }

  updateLaunchPad(launchpadObj) {
    const requestOptions: object = {
      responseType: 'text',
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    };
    const strURL =
      this.id == '1'
        ? 'v1/launchpad/updateCandidateLaunchpadData'
        : 'v1/launchpad/updateCandidateLaunchpadData?screenName=Fresher';
    return this.httpclient.post<any>(this.offerWfUrl + strURL, launchpadObj, requestOptions);
  }

  indentBlock(indentObj) {
    const requestOptions: object = {
      responseType: 'text',
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    };
    return this.httpclient.post<any>(this.offerWfUrl + 'v1/indent/blockILIndentDetails', indentObj, requestOptions);
  }

  openIndent(openObject) {
    const requestOptions: object = {
      responseType: 'text',
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    };

    return this.httpclient.post<any>(this.offerWfUrl + 'v1/indent/reOpenILIndents', openObject, requestOptions);
  }

  blockBudget(aid, actid) {
    const requestOptions: object = {
      responseType: 'text',
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    };
    return this.httpclient.post<any>(
      this.offerWfUrl + 'v1/vendor/blockBudgetCommitment/' + aid + '/' + actid,
      requestOptions,
    );
  }

  getDnhType(candidateId) {
    const actId = this.dataIds.activityID;
    const url222 = this.offerWfUrl + '/v1/dnh/doNotHireCheck/' + actId + '/' + candidateId;
    return this.httpclient.get<any>(url222);
  }
  unblockIndent(applicationID, indentmodal) {
    return this.httpclient.post<any>(this.offerWfUrl + 'v1/indent/reOpenILIndents/' + applicationID, indentmodal, {
      responseType: 'json',
    });
  }

  unBlockBudget(applicationID, activityID) {
    return this.httpclient.post<any>(
      this.offerWfUrl + 'v1/vendor/unblockBudgetCommitment/' + applicationID + '/' + activityID,
      {},
    );
  }

  fetchTemplate(data) {
    const requestOptions: object = {
      responseType: 'text',
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    };

    return this.httpclient.post<any>(
      this.offerTestUrl + '/modules/getTemplateAndClausesFiltered',
      data,
      requestOptions,
    );
  }

  fetchJoiningBonus(role) {
    const requestOptions: object = {
      responseType: 'text',
    };
    if (this.id == '4') {
      return this.httpclient.post<any>(
        this.offerWfUrl + 'updateOfferDetails/joiningBonus?role=' + role + '&hiring_type=' + this.id,
        requestOptions,
      );
    } else {
      return this.httpclient.post<any>(
        this.offerWfUrl + '/updateOfferDetails/joiningBonus?role=' + role,
        requestOptions,
      );
    }
  }

  withdraw(offer_id) {
    const requestOptions: object = {
      responseType: 'text',
    };
    return this.httpclient.post<any>(
      this.offerWfUrl + '/updateOfferDetails/joiningBonusWithdraw?offerId=' + offer_id,
      requestOptions,
    );
  }

  updateOfferWrapper(obj) {
    const requestOptions: object = {
      responseType: 'text',
    };
    return this.httpclient.post<any>(
      this.offerWfUrl + 'updateOfferDetails/updateOfferDetailsWrapper',
      obj,
      requestOptions,
    );
  }

  sendCommunication(mailbody) {
    const requestOptions: object = {
      responseType: 'text',
    };
    // return this.httpclient.post(this.emailAPI,mailbody)
    return this.httpclient.post<any>(
      this.offerWfUrl + 'updateOfferDetails/updateOfferDetailsWrapperMailer',
      mailbody,
      requestOptions,
    );
    // return this.httpclient.post("https://intaptest.infosysapps.com/infosys/intapoffers/mail/sendMail",mailbody)
  }

  getCoverLetter(id) {
    return this.httpclient.get<any>(this.offerTestUrl + 'v1/getCoverLetters/' + id);
  }

  joiningbonus_mailer(mailbody) {
    const requestOptions: object = {
      responseType: 'text',
    };
    // return this.httpclient.post(this.emailAPI,mailbody)
    return this.httpclient.post(this.offerWfUrl + 'mailer/mailerWrapper ', mailbody, requestOptions);
    // return this.httpclient.post("https://intaptest.infosysapps.com/infosys/intapoffers/mail/sendMail",mailbody)
  }

  getSezAddress(cityId, estType) {
    const addressUrl = this.addressApi + 'modules/getAddress/' + cityId + '/' + estType;
    return this.httpclient.get(addressUrl);
  }

  getFlag(appId: string, SkipSFOActiveFlag?: string): Observable<any> {
    const url = `${this.recruiterUrl}iwp/getPanelListId?applicationId=${appId}${
      SkipSFOActiveFlag ? `&SkipSFOActiveFlag=${SkipSFOActiveFlag}` : ''
    }`;
    return this.httpclient.get<any>(url);
  }

  checkBpm(appId) {
    const requestOptions: object = {
      responseType: 'text',
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    };
    return this.httpclient.get<any>(
      this.offerTestUrl + 'panelList/v1/panelListCheckBPM?applicationId=' + appId,
      requestOptions,
    );
  }
  getSFO(CanID, CmHrTypeID, appId) {
    const requestOptions: object = {
      responseType: 'text',
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    };
    return this.httpclient.get<any>(
      this.offerDB_URL +
        'validateCandidate?candidateId=' +
        CanID +
        '&companyHiringTypeId=' +
        CmHrTypeID +
        '&applicationId=' +
        appId,
      requestOptions,
    );
  }

  // getSupportTeamMember(searchText, applicationID) {
  //   return this.httpclient.get<any>(this.recruiterUrl + 'panelist/checkPanelistEligility?empNo=' + searchText + '&applicationId=' + applicationID);
  // }
  getSupportTeamMember(searchText, applicationID) {
    const body = { empId: searchText, applicationId: applicationID, companyId: null, email: null };
    return this.httpclient.post<any>(this.recruiterUrl + 'panelist/checkPanelistEligility', body);
  }
  getHrDetail(searchText) {
    const body = { empNumber: searchText };
    return this.httpclient.post<any>(this.supportUrl, body);
  }

  getInterviewDetails(candidateId) {
    return this.httpclient.get<any>(
      this.confirmation_url +
        'getCandidateInterviewHistory?candidateId=' +
        candidateId +
        '&companyHiringTypeId=' +
        this.id,
    );
  }

  getEmployeeDetails(IDlist): Observable<any> {
    return this.httpclient.post<any>(this.loggedUserDetailsUrl + 'getAllEmpDetails', IDlist);
  }

  recallOffer(appId) {
    const requestOptions: object = {
      responseType: 'text',
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    };

    return this.httpclient.post(this.offerWfUrl + 'v1/offerRecall/activity/' + appId, requestOptions);
  }

  getCityId(appiD, value) {
    return this.httpclient.get<any>(
      this.offerTestUrl + '/getAllCities/Lateral/CombinedSearch/' + appiD + '/' + value + '/null/' + this.id,
    );
  }
  blockIndentBpm(obj) {
    const requestOptions: object = {
      responseType: 'text',
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    };
    return this.httpclient.post<any>(
      this.offerWfUrl + 'v1/indent/blockAndMappingBPOIndentDetails',
      obj,
      requestOptions,
    );
  }
  openIndentBpm(obj) {
    const requestOptions: object = {
      responseType: 'text',
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    };
    return this.httpclient.post<any>(
      this.offerWfUrl + 'v1/indent/unBlockAndUnMappingBPOIndentDetails',
      obj,
      requestOptions,
    );
  }
  indentdeletion(obj) {
    return this.httpclient.post<any>(this.offerWfUrl + 'v1/bpmOnline/indentDeletion', obj);
  }

  blockIndentBpm_doj(obj) {
    const requestOptions: object = {
      responseType: 'text',
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    };
    const flag = 'updateOfferDetails';

    return this.httpclient.post<any>(
      this.offerWfUrl + 'v1/indent/blockAndMappingBPOIndentDetails?flag=' + flag,
      obj,
      requestOptions,
    );
  }

  ///////offer revoke/////
  saveUpdateRevokeWrapper(object: OfferRevokeDetails) {
    const requestOptions: object = {
      responseType: 'text',
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    };

    return this.httpclient.post<any>(this.offerWfUrl + 'propose/revokeOfferWrapper', object, requestOptions);
  }

  offerRecallApprover(appId) {
    const requestOptions: object = {
      responseType: 'text',
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    };

    return this.httpclient.post<any>(this.offerWfUrl + 'v1/offerRecall/activityRecall/' + appId, requestOptions);
  }

  getAddress(id) {
    return this.httpclient.get<any>(this.offerTestUrl + 'v1/search/getDetailsByCandidateID/' + id);
  }

  forwardCandidate(process, request, compId, data: any) {
    return this.httpclient.post<any>(
      this.candidateHiringNameUrl +
        'candidate/forward?processName=' +
        process +
        '&requestName=' +
        request +
        '&companyHiringTypeId=' +
        compId,
      data,
    );
  }
  get lastActivityPerformed() {
    return this.lastActivity;
  }

  set lastActivityPerformed(activity) {
    this.lastActivity = activity;
  }
  get allActivityPerformed() {
    return this.allActivity;
  }
  set allActivityPerformed(activity) {
    this.allActivity = activity;
  }
  get activityAPICheck() {
    return this._check.asObservable();
  }
  set activityAPICheck(value: any) {
    this._check.next(value);
  }

  quitPanelist(actvId) {
    return this.httpclient.get<any>(this.BASE_URL + 'activity/getQuitPanelist?applicationId=' + actvId);
  }

  saveBonusAttachment(attachmentObj) {
    const requestOptions: object = {
      responseType: 'text',
    };
    if (this.id == '4') {
      return this.httpclient.post<any>(
        this.offerWfUrl + 'mailer/additionalMailerWrapper?hiring_type=' + this.id,
        attachmentObj,
        requestOptions,
      );
    } else {
      return this.httpclient.post<any>(
        this.offerWfUrl + 'mailer/additionalMailerWrapper',
        attachmentObj,
        requestOptions,
      );
    }
  }
  getSpclBns(templateId) {
    return this.httpclient.get(this.offerTestUrl + `v1/getSpecialBonus/${templateId}`);
  }

  pushResumefromIntapToIWP(resumeObj) {
    const requestOptions: object = {
      responseType: 'text',
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    };
    return this.httpclient.post<any>(this.resumePushUrl + 'AWS/uploadDocsToAWSBucketIWP', resumeObj, requestOptions);
  }

  sendRefMail(appId) {
    return this.httpclient.get<any>(this.offerWfUrl + 'v1' + '/mailer/getMailerforEmpRef/' + appId);
  }

  whatsAppDP(whatsAppDP) {
    return this.httpclient.post<any>(this.recruiterUrl + 'RecruiterModule/SendwhatsappMessageHRPending', whatsAppDP);
  }

  getHRchecklist(appId) {
    // return this.httpclient.get<any>('https://intaptest.infosysapps.com/infosys/intaprecruiter/v1/Hrpanel/getHrCheckDetails?application_id='  appId);
    return this.httpclient.get<any>(
      this.recruiterDashboardUrl + 'v1/Hrpanel/getHrCheckDetails?application_id=' + appId,
    );
  }

  getHRchecklistStatus(appId, candId) {
    // return this.httpclient.get<any>('https://intaptest.infosysapps.com/infosys/intaprecruiter/v1/Hrpanel/getHrCheckDetails?application_id='  appId);
    return this.httpclient.get<any>(this.recruiterDashboardUrl + 'v1/Hrpanel/checklistStatus/' + candId + '/' + appId);
  }
  regenerateHRchecklist(appId, candId) {
    const requestOptions: object = {
      responseType: 'text',
    };
    return this.httpclient.post<string>(
      this.careerUrl + 'candidateWrapperServices/ilPdfGeneration?candidateId=' + candId + '&applicationId=' + appId,
      '',
      requestOptions,
    );
  }
  saveHRchecklist(reqBody) {
    // return this.httpclient.get<any>(https://intaptest.infosysapps.com/infosys/intaprecruiter/v1/Hrpanel/saveHrCheckDetails, reqBody);
    return this.httpclient.post<any>(this.recruiterDashboardUrl + 'v1/Hrpanel/saveHrCheckDetails', reqBody);
  }

  getAllOfferTypes() {
    return this.httpclient.get<any>(this.recruiterDashboardUrl + 'v1/Hrpanel/getAllOfferTypes');
  }

  jitOfferVldMsg(jit) {
    return this.httpclient.post<any>(this.offerWfUrl + '/updateOfferDetails/updateOfferDetailsWrapperEHC', jit);
  }
  s2hStatusUpdate(canId, applnId) {
    return this.httpclient.get<any>(this.ProfileUrl + 's2h/statusUpdate/' + canId + '/' + applnId);
  }

  update_S2rlStatus(data) {
    return this.httpclient.post<any>(
      this.ProfileUrl + 's2h/updateS2rlCandidateStatus/' + data.candidateId + '/' + data.appId,
      null,
    );
  }

  getGenModelLateralStructure(applicationId, screenName) {
    return this.httpclient.get<any>(
      this.offerTestUrl + '/getGenModelLateralStructure/' + screenName + '/' + applicationId,
    );
  }

  unblockChinaIndent(indentObj) {
    return this.httpclient.post<any>(this.offerWfUrl + 'v1/china/indent/reOpenChinaIndents', indentObj);
  }

  getFilteredEstTypes(cityId) {
    return this.httpclient.get(this.offerTestUrl + '/getEstablishmentTypeByPostingLocation/' + cityId);
  }

  addressUrl(cityId, estType) {
    return this.httpclient.get(this.offerTestUrl + 'modules/getAddress/' + cityId + '/' + estType);
  }

  getOfferAcceptCheck(applicationId) {
    return this.httpclient.get<any>(
      this.offerWfUrl + 'v1/offerRejectRevert/offerValidation?applicationId=' + applicationId,
    );
    //return this.httpclient.get<any>("assets/json/offerAccept.json")
  }
}
